let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("9VcQN")).then(() => parcelRequire('3RLpu'));